/** The most views an author may ask for. */
export const GRID_MAX_VIEWS = 12;

/** How many views a config that never named a count gets. */
export const GRID_DEFAULT_VIEWS = 2;

/** The field a folded row keeps its main value in, which is also the id of the column showing it. */
export const GRID_MAIN_VALUE_KEY = 'group:value';
